import React from "react";
import withUser from "../hoc/withUser";
import { withRouter } from "react-router-dom";
import {
  Button,
  InputBase,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Snackbar,
  SnackbarContent
} from "@material-ui/core";
import Layout from "../layouts/Layout";
// import InputBase from "@material-ui/core/InputBase";
// import Table from "@material-ui/core/Table";
// import TableBody from "@material-ui/core/TableBody";
// import TableCell from "@material-ui/core/TableCell";
// import TableHead from "@material-ui/core/TableHead";
// import TableRow from "@material-ui/core/TableRow";
// import Snackbar from "@material-ui/core/Snackbar";
import WarningIcon from "@material-ui/icons/Warning";
// import SnackbarContent from "@material-ui/core/SnackbarContent";
import classNames from "classnames";
import { grey, white, black, darkGrey, primaryShade1 } from "../styles/color";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const variantIcon = {
  warning: WarningIcon
};
const stylesSnackbar = theme => ({
  warning: {
    backgroundColor: theme.palette.error.dark
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});
function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      {...other}
    />
  );
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["warning"]).isRequired
};

const MySnackbarContentWrapper = withStyles(stylesSnackbar)(MySnackbarContent);
class AddInvoicePrintData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      companyName: null,
      companyAddress: null,
      stdCode: null,
      offPhone1: null,
      offPhone2: null,
      fax: null,
      residence: null,
      jurisdictionDetails: null,
      bankDetails: null,
      accountNumber: null,
      panNumber: null,
      rtgsNumber: null,
      dataStatus: "add",
      invoicePrintDataId: null,
      openSnackBar: false,
      organisationId: null
    };
  }
  componentWillMount() {
    this.initializeData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.initializeData(nextProps);
  }
  initializeData = whichProps => {
    if (whichProps.currentInvoiceData.length > 0) {
      this.setState({
        companyName: whichProps.currentInvoiceData[0].companyName,
        companyAddress: whichProps.currentInvoiceData[0].companyAddress,
        stdCode: whichProps.currentInvoiceData[0].stdCode,
        offPhone1: whichProps.currentInvoiceData[0].offPhone1,
        offPhone2: whichProps.currentInvoiceData[0].offPhone2,
        fax: whichProps.currentInvoiceData[0].faxNumber,
        residence: whichProps.currentInvoiceData[0].residencePhone,
        jurisdictionDetails:
          whichProps.currentInvoiceData[0].jurisdictionDetails,
        bankDetails: whichProps.currentInvoiceData[0].bankDetails,
        accountNumber: whichProps.currentInvoiceData[0].accountNumber,
        panNumber: whichProps.currentInvoiceData[0].panNumber,
        rtgsNumber: whichProps.currentInvoiceData[0].rtgsNumber,
        dataStatus: "update",
        invoicePrintDataId: whichProps.currentInvoiceData[0].id
      });
    }
    if (whichProps.organisations !== undefined) {
      this.setState({
        organisationId: whichProps.organisations.organisationId
      });
    }
  };
  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };
  handleOpenSnackBar = () => {
    this.setState({ openSnackBar: true });
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({ openSnackBar: false });
  };
  render() {
    const { addInvoicePrintData } = this.props;
    const {
      companyName,
      companyAddress,
      stdCode,
      offPhone1,
      offPhone2,
      fax,
      residence,
      jurisdictionDetails,
      bankDetails,
      accountNumber,
      panNumber,
      rtgsNumber,
      dataStatus,
      invoicePrintDataId,
      organisationId
    } = this.state;
    return (
      <Layout
        position="static"
        appBar
        appBarTitle={"ADD PRINT DETAILS"}
        appBarLeftIcon={true}
      >
        <div className="mainDiv" style={{
          display: "flex",
          flexDirection: "column",
          top: "66px",
          justifyContent: "space-between",
          position: "absolute",
          width: "100vw",
          height: "calc(100vh - 122px)",
          overflowY: "scroll",
          border: "1px solid black"
        }}>
          <div style={{ display: "flex", flex: 1 }}>
            <InputBase
              onChange={this.handleChange("companyName")}
              style={{
                width: "100%",
                color: black,
                fontSize: "1.2em"
              }}
              value={companyName}
              inputProps={{
                style: { textAlign: "center", color: black }
              }}
              placeholder="Enter Organisation Name Here"
              fullWidth={true}
            />
          </div>
          <div style={{ display: "flex", flex: 1, border: "1px solid black", }}>
            <InputBase
              onChange={this.handleChange("companyAddress")}
              style={{
                width: "100%",
                fontSize: "0.8em"
              }}
              value={companyAddress}
              inputProps={{
                style: { textAlign: "center", color: black }
              }}
              placeholder="Enter Address Here"
              fullWidth={true}
            />
          </div>
          <div style={{ display: "flex", flex: 2, flexDirection: "column" }}>


            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-around",
                border: "1px solid black",
                fontSize: "0.9em",
                color: black,
                flexDirection: "column",
                backgroundColor: darkGrey
              }}
            >
              <span style={{ display: "flex", justifyContent: "center" }}>
                Enter Contact Details Below:
                </span>
              <div
                style={{
                  backgroundColor: white,
                  width: "100%"
                }}
              >
                <InputBase
                  type="number"
                  onChange={this.handleChange("stdCode")}
                  style={{
                    width: "20%",
                    border: "1px solid black",
                    fontSize: "0.9em"
                  }}
                  value={stdCode}
                  inputProps={{
                    style: { textAlign: "center", color: black }
                  }}
                  placeholder="STD CODE"
                  fullWidth={true}
                />
                <InputBase
                  type="number"
                  onChange={this.handleChange("offPhone1")}
                  value={offPhone1}
                  style={{
                    width: "20%",
                    border: "1px solid black",
                    fontSize: "0.9em"
                  }}
                  inputProps={{
                    style: { textAlign: "center", color: black }
                  }}
                  placeholder="OFF PHONE 1"
                  fullWidth={true}
                />
                <InputBase
                  type="number"
                  onChange={this.handleChange("offPhone2")}
                  value={offPhone2}
                  style={{
                    width: "20%",
                    border: "1px solid black",
                    fontSize: "0.9em"
                  }}
                  inputProps={{
                    style: { textAlign: "center", color: black }
                  }}
                  placeholder="OFF PHONE 2"
                  fullWidth={true}
                />
                <InputBase
                  type="number"
                  onChange={this.handleChange("fax")}
                  value={fax}
                  style={{
                    width: "20%",
                    border: "1px solid black",
                    fontSize: "0.9em"
                  }}
                  inputProps={{
                    style: { textAlign: "center", color: black }
                  }}
                  placeholder="FAX NO"
                  fullWidth={true}
                />
                <InputBase
                  type="number"
                  onChange={this.handleChange("residence")}
                  value={residence}
                  style={{
                    width: "20%",
                    border: "1px solid black",
                    fontSize: "0.9em"
                  }}
                  inputProps={{
                    style: { textAlign: "center", color: black }
                  }}
                  placeholder="RESI."
                  fullWidth={true}
                />
              </div>

              <InputBase
                disabled
                style={{
                  width: "100%",
                  border: "1px solid black",
                  fontSize: "0.9em",
                  backgroundColor: darkGrey
                }}
                inputProps={{
                  style: { textAlign: "center", color: black }
                }}
                defaultValue="Product Data will be shown here."
                fullWidth={true}
              />
            </div>
          </div>
          <div style={{ display: "flex", flex: 6 }}><Table
            style={{
              border: "1px dotted black",
              borderCollapse: "collapse"
            }}
          >
            <TableHead>
              <TableRow
                style={{
                  backgroundColor: grey,
                  color: white
                }}
              >
                <TableCell
                  className="tableHeaderRow"
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    textAlign: "center",
                    color: white
                  }}
                >
                  <span style={{ fontSize: "0.8em" }}>Date</span>
                </TableCell>
                <TableCell
                  className="tableHeaderRow"
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    color: white
                  }}
                >
                  <span style={{ fontSize: "0.8em" }}>
                    Description City
                        </span>
                </TableCell>
                <TableCell
                  className="tableHeaderRow"
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    textAlign: "center",
                    color: white
                  }}
                >
                  <span style={{ fontSize: "0.8em" }}>
                    Goods Name / Rate
                        </span>
                </TableCell>
                <TableCell
                  className="tableHeaderRow"
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    textAlign: "center",
                    color: white
                  }}
                >
                  <span style={{ fontSize: "0.8em" }}>
                    Truck Quantity
                        </span>
                </TableCell>
                <TableCell
                  className="tableHeaderRow"
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    textAlign: "center",
                    color: white
                  }}
                >
                  <span style={{ fontSize: "0.8em" }}>
                    Bag / Truck /Wht
                        </span>
                </TableCell>
                <TableCell
                  className="tableHeaderRow"
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    textAlign: "center",
                    color: white
                  }}
                >
                  <span style={{ fontSize: "0.8em" }}>Rate</span>
                </TableCell>
                <TableCell
                  className="tableHeaderRow"
                  style={{
                    borderBottom: "1px dotted black",
                    padding: " 1px 1px 1px 1px",
                    textAlign: "center",
                    color: white
                  }}
                >
                  <span style={{ fontSize: "0.8em" }}>Amount</span>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{}}>
              <TableRow
                className="tableHeaderRow"
                style={{
                  backgroundColor: grey,
                  color: white
                }}
              >
                <TableCell
                  className="tableHeaderRow"
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    textAlign: "left"
                  }}
                  component="th"
                  scope="row"
                />
                <TableCell
                  className="tableHeaderRow"
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    textAlign: "left"
                  }}
                />
                <TableCell
                  className="tableHeaderRow"
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    textAlign: "left"
                  }}
                />
                <TableCell
                  className="tableHeaderRow"
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    textAlign: "left"
                  }}
                />
                <TableCell
                  className="tableHeaderRow"
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    textAlign: "left"
                  }}
                />
                <TableCell
                  className="tableHeaderRow"
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    textAlign: "left"
                  }}
                />
                <TableCell
                  className="tableHeaderRow"
                  style={{
                    borderBottom: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    textAlign: "right"
                  }}
                />
              </TableRow>

              <TableRow>
                <TableCell
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px"
                  }}
                  align="left"
                  colSpan={4}
                >
                  <InputBase
                    onChange={this.handleChange("jurisdictionDetails")}
                    style={{
                      width: "100%",
                      border: "1px solid black",
                      fontSize: "0.8em"
                    }}
                    value={jurisdictionDetails}
                    inputProps={{
                      style: { textAlign: "center", color: black }
                    }}
                    placeholder="Enter Jurisdiction Details Here"
                  />

                  <br />
                  <InputBase
                    onChange={this.handleChange("bankDetails")}
                    style={{
                      width: "100%",
                      border: "1px solid black",
                      fontSize: "0.8em"
                    }}
                    value={bankDetails}
                    inputProps={{
                      style: { textAlign: "center", color: black }
                    }}
                    placeholder="Enter Bank Details Here"
                  />
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    backgroundColor: grey,
                    color: white
                  }}
                  align="right"
                  colSpan={2}
                >
                  <span style={{ fontSize: "0.8em" }}>TOTAL</span>
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    backgroundColor: grey,
                    color: white
                  }}
                  align="right"
                  colSpan={1}
                />
              </TableRow>
              <TableRow>
                <TableCell
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px"
                  }}
                  align="left"
                  colSpan={4}
                >
                  <InputBase
                    onChange={this.handleChange("accountNumber")}
                    style={{
                      width: "100%",
                      border: "1px solid black",
                      fontSize: "0.8em"
                    }}
                    value={accountNumber}
                    inputProps={{
                      style: { textAlign: "center", color: black }
                    }}
                    placeholder="Enter Account Number Here"
                  />

                  <br />

                  <InputBase
                    onChange={this.handleChange("rtgsNumber")}
                    style={{
                      width: "100%",
                      border: "1px solid black",
                      fontSize: "0.8em"
                    }}
                    value={rtgsNumber}
                    inputProps={{
                      style: { textAlign: "center", color: black }
                    }}
                    placeholder="Enter RTGS Number Here"
                  />
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    backgroundColor: grey,
                    color: white
                  }}
                  align="right"
                  colSpan={2}
                >
                  <span style={{ fontSize: "0.8em" }}>ADD</span>
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    backgroundColor: grey,
                    color: white
                  }}
                  align="right"
                  colSpan={1}
                >
                  {" "}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px"
                  }}
                  align="left"
                  colSpan={4}
                >
                  <InputBase
                    onChange={this.handleChange("panNumber")}
                    style={{
                      width: "100%",
                      border: "1px solid black",
                      fontSize: "0.8em"
                    }}
                    value={panNumber}
                    inputProps={{
                      style: { textAlign: "center", color: black }
                    }}
                    placeholder="Enter PAN Number Here"
                  />
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    backgroundColor: grey,
                    color: white
                  }}
                  align="right"
                  colSpan={2}
                >
                  <span style={{ fontSize: "0.8em" }}> SUB</span>
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    backgroundColor: grey,
                    color: white
                  }}
                  align="right"
                  colSpan={1}
                >
                  {" "}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    backgroundColor: grey,
                    color: white
                  }}
                  align="left"
                  colSpan={4}
                />
                <TableCell
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    backgroundColor: grey,
                    color: white
                  }}
                  align="right"
                  colSpan={2}
                >
                  <span style={{ fontSize: "0.8em" }}>NET TOTAL</span>
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px",
                    backgroundColor: grey,
                    color: white
                  }}
                  align="right"
                  colSpan={1}
                >
                  {" "}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  style={{
                    borderBottom: "1px dotted black",
                    borderRight: "1px dotted black",
                    padding: "1px 1px 1px 1px"
                  }}
                  colSpan={7}
                  align="right"
                >
                  <span> {companyName} </span>
                  <br />
                  <span style={{ fontSize: "0.65em" }}>
                    Auth Signature
                        </span>{" "}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table></div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "56px",
            position: "absolute",
            bottom: "0px",
            alignItems: "center",
            justifyContent: "center"
          }}
        >  <Button
          variant="contained"
          color="primary"
          onClick={e => {
            e.preventDefault();
            if (
              !companyName ||
              companyName === "" ||
              !companyAddress ||
              companyAddress === "" ||
              !stdCode ||
              stdCode === "" ||
              !offPhone1 ||
              offPhone1 === "" ||
              !offPhone2 ||
              offPhone2 === "" ||
              !fax ||
              fax === "" ||
              !residence ||
              residence === "" ||
              !jurisdictionDetails ||
              jurisdictionDetails === "" ||
              !bankDetails ||
              bankDetails === "" ||
              !accountNumber ||
              accountNumber === "" ||
              !panNumber ||
              panNumber === "" ||
              !rtgsNumber ||
              rtgsNumber === ""
            ) {
              this.handleOpenSnackBar();
            } else {
              const printInvoiceData = {
                companyName: companyName,
                companyAddress: companyAddress,
                stdCode: stdCode,
                offPhone1: offPhone1,
                offPhone2: offPhone2,
                faxNumber: fax,
                residencePhone: residence,
                jurisdictionDetails: jurisdictionDetails,
                bankDetails: bankDetails,
                accountNumber: accountNumber,
                panNumber: panNumber,
                rtgsNumber: rtgsNumber,
                userId: this.props.user.uid,
                organisationId: organisationId,
                createdAt: new Date()
              };
              addInvoicePrintData(
                printInvoiceData,
                dataStatus,
                invoicePrintDataId
              );
              this.props.history.goBack();
            }
          }}
          style={{
            backgroundColor: primaryShade1,
            color: "white",
            width: "100%",
            height: "100%"
          }}
        >
            ADD
        </Button><Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center"
            }}
            open={this.state.openSnackBar}
            autoHideDuration={3000}
            onClose={this.handleClose}
          >
            <MySnackbarContentWrapper
              onClick={this.handleClose}
              variant="warning"
              message="Please Fill All Fields!"
            />
          </Snackbar>
        </div>
      </Layout>
    );
  }
}

export default withRouter(withUser(AddInvoicePrintData));